import { Button } from "antd";
import React, { useState } from "react";

const parameters = [
  { id: 1, name: "Parameter 1", issue: "Issue with Trader Address" },
  { id: 2, name: "Parameter 2", issue: "Incorrect threshold values" },
  { id: 3, name: "Parameter 3", issue: "Sensor misalignment detected" },
];

const enclosures = [
  { id: 1, name: "Enclosure 1", pdfUrl: "/pdfs/enclosure1.pdf" },
  { id: 2, name: "Enclosure 2", pdfUrl: "/pdfs/enclosure2.pdf" },
  { id: 3, name: "Enclosure 3", pdfUrl: "/pdfs/enclosure3.pdf" },
];

const TraderRectificationComponent: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const handleShow = (modal: string) => {
    setActiveModal(modal);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setActiveModal(null);
  };

  return (
    <div className="container-fluid">
      <div className="page-wrapper">
        <div className="card mt-3 p-6 m-4">
          <div className="card-body">
            <div className="text fs-18 fw-bold">
            License Rejection and Re-Submission Process -
              <span className="fs-14 fw-normal">
                {" "}
                This license has been rejected by the Approval Authority. To proceed with re-submission, the following steps must be followed:
              </span>
              <div className="fs-18 fw-bold text-info">
              Steps to Rectify and Re-Submit the Application:
                <ul className="list-unstyled mt-2">
                  <li className="fs-14">
                    🔹{" "}
                    <span>
                    Retrieve and Review Identified Issues

                    </span>
                  </li>
                  <li className="fs-14">
                    🔹{" "}
                    <span>
                    Make the necessary corrections and re-submit the application for review.
                    </span>
                  </li>
                </ul>
              </div>
              <div className="container mt-2">
                <div className="d-flex align-items-center  gap-3">
                  <button
                    className="btn btn-primary "
                    onClick={() => handleShow("modal1")}
                  >
                    Identified Issues
                  </button>

                  <button
                    className="btn btn-secondary ml-2"
                    onClick={() => handleShow("modal2")}
                  >
                    Make Correction
                  </button>
                </div>

                {/* Modal */}
                {showModal && (
                  <div
                    className="modal show d-block"
                    tabIndex={-1}
                    style={{ background: "rgba(0,0,0,0.5)" }}
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">
                            {activeModal === "modal1"
                              ? "Identified Issues"
                              : "Make Correction"}
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={handleClose}
                          ></button>
                        </div>
                        <div className="modal-body">
                          {activeModal === "modal1" ? (
                            <p>
                              <strong>Identified Issues in Application</strong>
                              <br />
                              The following issues have been identified in the
                              submitted application. Please address them to
                              proceed. <br />
                              <br />
                              <strong>
                                Incomplete or Incorrect Information
                              </strong>{" "}
                              – Missing or inaccurate details in the application
                              form.
                              <br />
                              <strong>Document Discrepancies</strong> – Uploaded
                              documents are incorrect, outdated, or do not meet
                              the prescribed format.
                              <br />
                              <strong>Eligibility Non-Compliance</strong> – The
                              application does not meet the required eligibility
                              criteria.
                              <br />
                              <strong>Payment Issues</strong> – Pending or
                              unsuccessful payment of applicable fees.
                              <br />
                              <strong>
                                Signature or Authorization Missing
                              </strong>{" "}
                              – Required signatures or authorization details are
                              missing.
                              <br />
                              <strong>Supporting Evidence Required</strong> –
                              Additional supporting documents are needed.
                              <br />
                              <br />
                              <strong>Next Steps:</strong>
                              <br />- Review the identified issues carefully.
                              <br />- Rectify the errors and provide necessary
                              updates.
                              <br />- Re-submit the application for further
                              processing.
                            </p>
                          ) : (
                            <p>
                              <strong>Make Correction</strong>
                              <br />
                              Please follow these steps to make corrections in
                              your application:
                              <br />
                              <br />
                              1. Review the identified issues carefully.
                              <br />
                              2. Update your application with the correct
                              information.
                              <br />
                              3. Ensure all required documents are uploaded in
                              the prescribed format.
                              <br />
                              4. Complete the payment if it is pending.
                              <br />
                              5. Re-submit the application for review.
                            </p>
                          )}
                        </div>
                        <div className="modal-footer">
                          <button
                            className="btn btn-secondary"
                            onClick={handleClose}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraderRectificationComponent;
